import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

const NotAuthorizedPage = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #000814 0%, #001d3d 50%, #003566 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Subtle gradient orbs */}
      <Box
        sx={{
          position: "absolute",
          top: "10%",
          left: "10%",
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(0, 255, 136, 0.08) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "20%",
          right: "15%",
          width: 250,
          height: 250,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(0, 153, 255, 0.08) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <Container maxWidth="sm" sx={{ position: "relative", zIndex: 1, py: 8 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography
            variant="h1"
            component="h2"
            sx={{
              fontSize: { xs: "6rem", sm: "8rem" },
              fontWeight: 900,
              lineHeight: 1,
              mb: 2,
              background: "linear-gradient(45deg, #00ff88, #0099ff)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            403
          </Typography>
          <Typography
            variant="h5"
            component="h2"
            sx={{
              fontWeight: 700,
              color: "#fff",
              mb: 2,
            }}
          >
            Unauthorized Access
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "rgba(255, 255, 255, 0.8)",
              mb: 4,
              maxWidth: 360,
              mx: "auto",
            }}
          >
            Please sign in to proceed.
          </Typography>
          <Button
            component={Link}
            to="/fmr/sign-in"
            variant="contained"
            size="large"
            sx={{
              background: "linear-gradient(45deg, #00ff88, #0099ff)",
              color: "#000814",
              fontWeight: 700,
              borderRadius: "4px",
              px: 4,
              py: 1.5,
              boxShadow: "0 4px 20px rgba(0, 255, 136, 0.3)",
              "&:hover": {
                background: "linear-gradient(45deg, #00cc6d, #0077cc)",
                boxShadow: "0 6px 24px rgba(0, 255, 136, 0.4)",
              },
            }}
          >
            Go to login page
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default NotAuthorizedPage;
